import { render, staticRenderFns } from "./StepTab2.vue?vue&type=template&id=6cee49cb&scoped=true"
import script from "./StepTab2.vue?vue&type=script&lang=js"
export * from "./StepTab2.vue?vue&type=script&lang=js"
import style0 from "./StepTab2.vue?vue&type=style&index=0&id=6cee49cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cee49cb",
  null
  
)

export default component.exports